import { db } from '../../../App/+store/firebase';

export const saveDistrictAdvancedSettings = async (profile, data) => {
  if (profile && profile.isSuperAdmin == true && profile.role === 'districtAdmin') {
    const orgId = profile.organizationId;
    try {
      if (data) {
        await db
          .ref(`newDatabase/organizations/${orgId}/district/advancedSettings/menusVisibility`)
          .update(data.menusVisibility);
      }
    } catch (err) {
      console.error('Error: ', err);
    }
  } else {
    throw 'You do not have permissions to save district advanced settings';
  }
};

export const getDistrictAdvancedSettings = async (profile) => {
  const orgId = profile.organizationId;
  const districtSettings = (
    await db.ref(`newDatabase/organizations/${orgId}/district/advancedSettings`).once('value')
  ).val();
  return districtSettings;
};

// Persist the district's enrollment count source ('roster' | 'manual') and, when
// manual, the hand-entered per-campus counts. Stored directly under the district
// node so the A-F district report (which reads the whole district node) picks them up.
export const saveDistrictEnrollmentSettings = async (profile, { enrollmentSource, manualEnrollmentCounts }) => {
  if (!(profile && profile.isSuperAdmin == true && profile.role === 'districtAdmin')) {
    throw 'You do not have permissions to save district enrollment settings';
  }
  const orgId = profile.organizationId;
  const update = { enrollmentSource };
  if (manualEnrollmentCounts) {
    update.manualEnrollmentCounts = manualEnrollmentCounts;
  }
  await db.ref(`newDatabase/organizations/${orgId}/district`).update(update);
};
